import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium transition-colors focus:outline-none",
  {
    variants: {
      variant: {
        default: "bg-[var(--ink)] text-[var(--surface)]",
        secondary: "bg-[var(--chip)] text-[var(--ink-2)]",
        destructive: "bg-[var(--danger-bg)] text-[var(--danger-fg)]",
        brand: "bg-[var(--brand)] text-[var(--on-brand)]",
        outline: "border border-[var(--control)] text-[var(--ink-2)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
